import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectViewport } from '../../../store/address/address.selectors'
import { selectCurrentPolylineBbox } from '../../../store/itinerary/polylines.selectors'
import {
  selectIsMapInitialized,
  selectMapActiveBbox,
  selectMapBbox,
  selectMapSearchBbox
} from '../../../store/map/map.selectors'
import { isEmpty } from '../../../utils/lang'
import { selectStepsCoordinates } from '../../itinerary/steps/steps.selectors'
import { getBboxFromLngLatPoints } from '../../utils/map'
import { useMapContext } from '../MapContext'
import { bboxArrayToBboxArrays } from '../conversion'

const BboxDebugger = ({ bbox, id, fillColor = '#088' }) => {
  const { map } = useMapContext()
  const isMapInitialized = useSelector(selectIsMapInitialized)

  useEffect(() => {
    if (!map || !isMapInitialized || !bbox || !id) return

    const debugId = `${id}_debug_id`

    const [[x1, y1], [x2, y2]] = bbox
    const p1 = [Math.min(x1, x2), Math.min(y1, y2)]
    const p2 = [Math.max(x1, x2), Math.min(y1, y2)]
    const p3 = [Math.max(x1, x2), Math.max(y1, y2)]
    const p4 = [Math.min(x1, x2), Math.max(y1, y2)]

    const data = {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [[p1, p2, p3, p4, p1]]
      }
    }
    try {
      if (!isEmpty(map.getLayer(debugId))) {
        map.getSource(debugId).setData(data)
      } else {
        map.addLayer({
          id: debugId,
          type: 'fill',
          source: {
            type: 'geojson',
            data
          },
          paint: {
            'fill-color': fillColor,
            'fill-opacity': 0.3
          }
        })
      }
    } catch (error) {
      console.error('failed to getLayer', error)
    }

    return () => {
      try {
        if (map.getLayer(debugId)) {
          map.removeLayer(debugId)
          map.removeSource(debugId)
        }
      } catch (error) {
        console.error('failed to getLayer', error)
      }
    }
  }, [map, bbox?.toString(), id, isMapInitialized])

  return <></>
}

export const ViewportDebugger = () => {
  const bbox = bboxArrayToBboxArrays(useSelector(selectViewport))
  return <BboxDebugger bbox={bbox} id={'viewport'} fillColor={'#083'} />
}

export const MapBboxDebugger = () => {
  const bbox = useSelector(selectMapBbox)
  return <BboxDebugger bbox={bbox} id={'mapbbox'} fillColor={'#909'} />
}

export const ActiveBboxDebugger = () => {
  const bbox = useSelector(selectMapActiveBbox)
  return <BboxDebugger bbox={bbox} id={'mapactivebbox'} fillColor={'#d80'} />
}

export const SearchBboxDebugger = () => {
  const bbox = useSelector(selectMapSearchBbox)
  return <BboxDebugger bbox={bbox} id={'mapsearchbbox'} fillColor={'#07d'} />
}

export const StepsDebugger = () => {
  const { departure, arrival } = useSelector(selectStepsCoordinates)
  const bbox = departure && arrival ? getBboxFromLngLatPoints([departure, arrival]) : null
  return <BboxDebugger bbox={bbox} id={'steps'} fillColor={'#086'} />
}

export const PolylineDebugger = () => {
  const bbox = useSelector(selectCurrentPolylineBbox)
  return <BboxDebugger bbox={bbox} id={'polyline'} fillColor={'#e42525'} />
}
